<template>
  <div
    style="
      top: 52%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 1100px;
      height: 670px;
      position: absolute;
    "
  >
    <selectRegionPanel
      style="
        zoom: 1.3;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
      v-if="regionselectflag === true"
      :cancelable="!!regionInfo.region_code"
      :current="regionInfo"
      @setregion="setregion"
      @cancel="regionselectflag = false"
    ></selectRegionPanel>
    
    <div v-if="regionselectflag === false" v-show="freelogin === false">
      <div v-if="schoolsearchflag === false">
        <div class="tabdiv">
          <div
            class="tabbtnleft"
            :class="{
              tabbtnactive: tab === 0,
              tabbtnunactive: tab === 1,
            }"
            @click="moveTab(0)"
          >
            <p class="tabbtntext">
              {{ getRegionName() }}
              {{ langlist[$store.state.lang]["ID 로그인"] }}
            </p>
          </div>
        </div>
        <div class="logindiv">
          <div style="width: 1100px; height: 72px">
            <div style="float: left" v-show="schoolInfo.schoolCode">
              <div
                class="schoolIcon"
                style="margin-left: 60px; margin-top: 20px"
              ></div>
              <p class="schoolText">
                {{ schoolInfo.schoolName }}
              </p>
            </div>
            <div style="float: right">
              <v-btn
                @click="schoolSearch()"
                :width="schoolSearchBtnWidth($store.state.lang)"
                class="schoolSearchBtn"
                outlined
                style="
                  color: white;
                  height: 58px;
                  font-size: 24px;
                  border: 1px solid #3f68d3;
                  margin-top: 20px;
                  margin-right: 90px;
                  font-family: notosans;
                "
                >{{ langlist[$store.state.lang]["학교 검색"] }}</v-btn
              >
            </div>
          </div>

          <div v-show="tab === 0" class="tabContentdiv">
            <input
              @keyup.enter="login()"
              v-model="id"
              autofocus
              type="text"
              :placeholder="langlist[$store.state.lang]['아이디']"
              class="idinput"
            />
            <input
              @keyup.enter="login()"
              v-show="iseyeopen == false"
              v-model="pw"
              type="password"
              :placeholder="langlist[$store.state.lang]['비밀번호']"
              class="pwinput"
            />
            <input
              @keyup.enter="login()"
              v-show="iseyeopen == true"
              type="text"
              v-model="pw"
              placeholder="Password"
              class="pwinput"
            />
            <div @click="login()" class="loginbtn"></div>
          </div>

          <div v-show="tab === 1" class="tabContentdiv">
            <div style="width: 100%; height: 60px; margin-top: 20px">
              <div style="margin-left: 60px; font-size: 24px">
                <div
                  @click="optionControl(0)"
                  class="selectContainer"
                  style="text-align: left"
                  :class="{
                    optionDown: currentOption !== 0,
                    optionUp: currentOption === 0,
                  }"
                >
                  <p
                    style="color: #a4b5e5; margin-left: 25px; margin-top: 8px"
                    v-show="grade === 0"
                  >
                    {{ langlist[$store.state.lang]["학년 선택"] }}
                  </p>
                  <p
                    style="color: #607ccd; margin-left: 25px; margin-top: 8px"
                    v-show="grade !== 0"
                  >
                    {{
                      langlist[$store.state.lang]["gradeLabel"].replace(
                        "{grade}",
                        grade
                      )
                    }}
                  </p>
                </div>
                <div
                  @click="optionControl(1)"
                  class="selectContainer"
                  style="margin-left: 150px"
                  :class="{
                    optionDown: currentOption !== 1,
                    optionUp: currentOption === 1,
                  }"
                >
                  <p
                    style="color: #a4b5e5; margin-left: 25px; margin-top: 8px"
                    v-show="classNum === 0"
                  >
                    {{ langlist[$store.state.lang]["반 선택"] }}
                  </p>
                  <p
                    style="color: #607ccd; margin-left: 25px; margin-top: 8px"
                    v-show="classNum !== 0"
                  >
                    {{
                      langlist[$store.state.lang]["classLabel"].replace(
                        "{classNum}",
                        classNum
                      )
                    }}
                  </p>
                </div>
                <div class="optionContent" v-show="currentOption === 0">
                  <div v-for="(j, i) in schoolInfo.gradeList" :key="i">
                    <div class="selectoption" @click="selectGrade(j)">
                      <p style="margin-left: 20px; font-family: notosans">
                        {{
                          langlist[$store.state.lang]["gradeLabel"].replace(
                            "{grade}",
                            j
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="optionContent"
                  style="margin-left: 565px"
                  v-show="currentOption === 1 && grade !== 0"
                >
                  <div
                    v-for="(j, i) in schoolInfo.classList[findGradeIndex()]"
                    :key="i"
                  >
                    <div class="selectoption" @click="selectClassNum(j)">
                      <p style="margin-left: 20px; font-family: notosans">
                        {{
                          langlist[$store.state.lang]["classLabel"].replace(
                            "{classNum}",
                            j
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <input
                @keyup.enter="login()"
                v-model="name"
                autofocus
                type="text"
                :placeholder="langlist[$store.state.lang]['이름']"
                class="idinput"
              />
              <input
                @keyup.enter="login()"
                v-show="iseyeopen == false"
                v-model="pw"
                type="password"
                :placeholder="langlist[$store.state.lang]['비밀번호']"
                class="pwinput"
              />
              <input
                @keyup.enter="login()"
                v-show="iseyeopen == true"
                type="text"
                v-model="pw"
                placeholder="Password"
                class="pwinput"
              />
              <div @click="login()" class="loginbtn"></div>
            </div>
          </div>
        </div>
      </div>
      <selectSchoolPanel
        style="
          zoom: 1.3;
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
        v-if="schoolsearchflag === true"
        @setschool="setschool()"
        @gofree="gofree(true)"
      ></selectSchoolPanel>
    </div>
    <div
      v-if="regionselectflag === false"
      v-show="freelogin === true"
      style="
        width: 1100px;
        height: 550px;
        background-color: rgba(182, 211, 255, 0.7);
        border-bottom-left-radius: 40px;
        border-bottom-right-radius: 40px;
        border-radius: 40px;
      "
    >
      <div style="float: left; margin-top: 20px">
        <div
          class="schoolIcon"
          style="margin-left: 60px; margin-top: 20px"
        ></div>
        <p class="schoolText">{{ langlist[$store.state.lang]["무료체험"] }}</p>
      </div>
      <input
        @keyup.enter="login()"
        v-model="id"
        autofocus
        type="text"
        :placeholder="langlist[$store.state.lang]['아이디']"
        class="idinput"
      />
      <input
        @keyup.enter="login()"
        v-show="iseyeopen == false"
        v-model="pw"
        type="password"
        :placeholder="langlist[$store.state.lang]['비밀번호']"
        class="pwinput"
      />
      <input
        @keyup.enter="login()"
        v-show="iseyeopen == true"
        type="text"
        v-model="pw"
        placeholder="Password"
        class="pwinput"
      />
      <div @click="login()" class="loginbtn"></div>
      <div
        v-if="$store.state.lang === 'ko'"
        @click="gofree(false)"
        class="nofreeSigninBtn"
      ></div>
    </div>
  </div>
</template>

<script>
import { getSaveCookie, deleteCookie } from "@/store/cookie.js";
import { getRegion } from "@/store/region";
import { userlogin, userinfo, schoolSearchByCode } from "../api.js";
import { ko, vt, en, zh, ja } from "@/_translate/translate.js";
import selectSchoolPanel from "./selectSchoolPanel.vue";
import selectRegionPanel from "./selectRegionPanel.vue";
import axios from "axios";

export default {
  data() {
    return {
      id: "",
      pw: "",
      grade: 0,
      classNum: 0,
      name: "",
      iseyeopen: false,
      maintenanceimg: false,
      langlist: {
        ko,
        vt,
        en,
        zh,
        ja,
      },
      schoolInfo: {
        schoolCode: "",
        schoolName: "",
        gradeList: [],
        classList: [],
      },
      regionInfo: {},
      tab: 0,
      schoolsearchflag: false,
      regionselectflag: false,
      freelogin: false,
      currentOption: -1,
    };
  },
  components: {
    selectSchoolPanel,
    selectRegionPanel,
  },
  async created() {
    const region = getRegion();

    // 저장된 국가가 없으면 무조건 국가 선택부터
    if (!region) {
      this.regionselectflag = true;
      return;
    }

    this.regionInfo = region;

    const schoolCode = getSaveCookie("schoolCode");
    if (schoolCode) {
      this.getSchoolInfo(schoolCode);
    } else {
      this.schoolsearchflag = true;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleOptionControl);
    window.addEventListener("regionSelect", this.regionSelect);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOptionControl);
    window.removeEventListener("regionSelect", this.regionSelect);
  },
  methods: {
    // 상단 "국가 설정" 버튼에서 발생시키는 이벤트
    regionSelect() {
      this.regionselectflag = true;
    },
    setregion(region) {
      const prevRegionCode = this.regionInfo.region_code;

      this.regionInfo = region;
      this.regionselectflag = false;

      // 국가가 바뀌면 서버가 달라지므로 이전 국가에서 고른 학교는 버린다
      if (prevRegionCode && prevRegionCode !== region.region_code) {
        deleteCookie("schoolCode");
        this.schoolInfo = {
          schoolCode: "",
          schoolName: "",
          gradeList: [],
          classList: [],
        };
        this.grade = 0;
        this.classNum = 0;
      }

      const schoolCode = getSaveCookie("schoolCode");
      if (schoolCode) {
        this.getSchoolInfo(schoolCode);
        this.schoolsearchflag = false;
      } else {
        this.schoolsearchflag = true;
      }
    },
    gofree(flag) {
      if (!flag) {
        const schoolCode = getSaveCookie("schoolCode");
        if (schoolCode) {
          this.schoolsearchflag = false;
        } else {
          this.schoolsearchflag = true;
        }
      }
      this.freelogin = flag;
    },
    getRegionName() {
      return this.$store.state.lang === 'ko' ? this.regionInfo.region_kr : this.regionInfo.region
    },
    handleOptionControl(e) {
      const ignoreSelector = ".selectContainer, .optionContent, .selectoption";
      if (e.target.closest(ignoreSelector)) {
        return;
      }

      this.currentOption = -1;
    },
    setschool() {
      const schoolCode = getSaveCookie("schoolCode");
      this.getSchoolInfo(schoolCode);
      this.schoolsearchflag = false;
    },
    schoolSearch() {
      this.schoolsearchflag = true;
    },
    async getSchoolInfo(schoolCode) {
      const res = (await schoolSearchByCode(schoolCode)).data.data;

      if (res.length) {
        this.schoolInfo.schoolCode = res[0].schoolCode;
        this.schoolInfo.schoolName = res[0].schoolName;
        this.schoolInfo.gradeList = res[0].classInfo.gradeList;
        this.schoolInfo.classList = res[0].classInfo.classList;
      }
    },
    moveTab(tab) {
      if (this.tab !== tab) {
        this.id = "";
        this.pw = "";
        this.iseyeopen = false;
        this.name = "";
        this.grade = 0;
        this.classNum = 0;
        this.tab = tab;
      }
    },
    optionControl(option) {
      if (option === 1 && this.grade === 0) {
        return;
      }

      if (this.currentOption === option) {
        this.currentOption = -1;
      } else {
        this.currentOption = option;
      }
    },
    selectGrade(grade) {
      if (this.grade !== grade) {
        this.classNum = 0;
      }
      this.grade = grade;
      this.currentOption = -1;
    },
    selectClassNum(classNum) {
      this.classNum = classNum;
      this.currentOption = -1;
    },
    findGradeIndex() {
      return this.schoolInfo.gradeList.findIndex((el) => el === this.grade);
    },
    async maintenance() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_CONNECT}/server/maintenance`,
          { credentials: true }
        );

        const data = res.data.data;

        return data;
      } catch {
        return true;
      }
    },
    getUserAgentDetails() {
      const ua = navigator.userAgent;
      let browserName = "Unknown Browser";
      let browserVersion = "Unknown Version";
      let os = "Unknown OS";

      // OS Detection
      if (ua.indexOf("Win") != -1) os = "Windows";
      else if (ua.indexOf("Mac") != -1) os = "MacOS";
      else if (ua.indexOf("X11") != -1) os = "UNIX";
      else if (ua.indexOf("Linux") != -1) os = "Linux";
      else if (ua.indexOf("Android") != -1) os = "Android";
      else if (ua.indexOf("like Mac") != -1) os = "iOS";

      // Browser Detection
      if (ua.indexOf("Firefox") != -1) {
        browserName = "Firefox";
        browserVersion = ua.substring(ua.indexOf("Firefox") + 8);
      } else if (ua.indexOf("Opera") != -1 || ua.indexOf("OPR") != -1) {
        browserName = "Opera";
        browserVersion =
          ua.substring(ua.indexOf("Opera") + 6) ||
          ua.substring(ua.indexOf("OPR") + 4);
      } else if (ua.indexOf("Chrome") != -1) {
        browserName = "Chrome";
        browserVersion = ua.substring(ua.indexOf("Chrome") + 7).split(" ")[0];
      } else if (ua.indexOf("Safari") != -1) {
        browserName = "Safari";
        browserVersion = ua.substring(ua.indexOf("Safari") + 7).split(" ")[0];
      } else if (ua.indexOf("MSIE") != -1 || ua.indexOf("Trident") != -1) {
        browserName = "Internet Explorer";
        browserVersion =
          ua.substring(ua.indexOf("MSIE") + 5) ||
          ua.substring(ua.indexOf("rv:") + 3);
      }

      // Format: OS_Browser Name_Browser Version
      return {
        os,
        browserName,
        browserVersion,
      };
    },
    eyeopen() {
      this.iseyeopen = !this.iseyeopen;
    },
    inputdisabled() {
      const target1 = document.getElementsByClassName("idinput");
      const target2 = document.getElementsByClassName("pwinput");

      target1[0].disabled = true;
      for (let i = 0; i < target2.length; i++) {
        target2[i].disabled = true;
      }
    },
    inputenabled() {
      const target1 = document.getElementsByClassName("idinput");
      const target2 = document.getElementsByClassName("pwinput");

      target1[0].disabled = false;
      for (let i = 0; i < target2.length; i++) {
        target2[i].disabled = false;
      }
    },
    async login() {
      if (!this.schoolInfo.schoolCode && this.freelogin === false) {
        const event = new CustomEvent("error", {
          detail: {
            errortext:
              this.langlist[this.$store.state.lang][
                "학교를 먼저 선택해주세요."
              ],
          },
        });
        window.dispatchEvent(event);
        return;
      }

      const id = this.id;
      const password = this.pw;

      this.inputdisabled();

      if (this.tab === 0) {
        if (!id || !password) {
          const event = new CustomEvent("error", {
            detail: {
              errortext: "Please enter your login information.",
            },
          });
          window.dispatchEvent(event);
          this.inputenabled();
          return;
        }
      }

      if (this.tab === 1) {
        if (!this.name || !password || !this.grade || !this.classNum) {
          const event = new CustomEvent("error", {
            detail: {
              errortext: "Please enter your login information.",
            },
          });
          window.dispatchEvent(event);
          this.inputenabled();
          return;
        }
      }

      const osInfo = this.getUserAgentDetails();
      const { os, browserName, browserVersion } = osInfo;
      const version = browserVersion.substring(0, 3);
      const osdata = `WebGL_${os}_${browserName}_${version}`;

      const languages = ["ko", "en", "ja", "zh"];

      const data = {
        type: "user",
        schoolCode: this.schoolInfo.schoolCode,
        id: id.trim(),
        password: password.trim(),
        os: osdata,
        grade: this.grade,
        classNum: this.classNum,
        name: this.name,
        language: languages.findIndex((el) => el === this.$store.state.lang),
      };

      if (this.freelogin) {
        data.type = "guest";
        data.schoolCode = "";
        data.grade = 0;
        data.classNum = 0;
        data.name = "";
      }

      const loadingEvent = new CustomEvent("loading", {
        detail: true,
      });

      window.dispatchEvent(loadingEvent);

      const res = await userlogin(data);

      const status = res.data.data.status;
      const token = res.data.data.token;

      if (status == -4) {
        const event = new CustomEvent("error", {
          detail: {
            errortext:
              this.langlist[this.$store.state.lang]["서버 점검 중입니다."],
          },
        });
        //this.maintenanceimg = true;

        const loadingEvent = new CustomEvent("loading", {
          detail: false,
        });

        window.dispatchEvent(loadingEvent);
        window.dispatchEvent(event);
        this.inputenabled();
        return;
      }

      if (status == -1) {
        const event = new CustomEvent("error", {
          detail: {
            errortext: this.langlist[this.$store.state.lang]["아이디 또는 비밀번호를 잘못 입력했습니다."],
          },
        });
        const loadingEvent = new CustomEvent("loading", {
          detail: false,
        });

        window.dispatchEvent(loadingEvent);
        window.dispatchEvent(event);
        this.inputenabled();
        return;
      }

      if (status == -2) {
        const event = new CustomEvent("error", {
          detail: {
            errortext: this.langlist[this.$store.state.lang]["아이디 또는 비밀번호를 잘못 입력했습니다."],
          },
        });
        const loadingEvent = new CustomEvent("loading", {
          detail: false,
        });

        window.dispatchEvent(loadingEvent);
        window.dispatchEvent(event);
        this.inputenabled();
        return;
      }

      if (status == -3) {
        const event = new CustomEvent("error", {
          detail: {
            errortext: this.langlist[this.$store.state.lang]["계약이 만료된 계정입니다."],
          },
        });
        const loadingEvent = new CustomEvent("loading", {
          detail: false,
        });

        window.dispatchEvent(loadingEvent);
        window.dispatchEvent(event);
        this.inputenabled();
        return;
      }

      if (token.toString().length < 10) {
        const event = new CustomEvent("error", {
          detail: {
            errortext: this.langlist[this.$store.state.lang]["로그인 중 오류가 발생하였습니다."],
          },
        });
        const loadingEvent = new CustomEvent("loading", {
          detail: false,
        });

        window.dispatchEvent(loadingEvent);
        window.dispatchEvent(event);
        this.inputenabled();
        return;
      }

      const info = await userinfo(token);
      const user = info.data.data;

      let first = false;
      if (!user.nickName) {
        first = true;
      }

      if (first) {
        const loadingEvent = new CustomEvent("loading", {
          detail: false,
        });

        window.dispatchEvent(loadingEvent);
      }

      const loginevent = new CustomEvent("loginChallenge", {
        detail: {
          key: "logininfo",
          first,
          token,
          userinfo: {
            id: user.userId,
            pw: this.pw,
            school: user.schoolName,
            name: user.name,
            nickName: user.nickName,
          },
        },
      });

      if (first) {
        window.dispatchEvent(loginevent);
      } else if (status === -6) {
        window.dispatchEvent(loginevent);
      } else if (!user.nickName) {
        //닉네임 설정 팝업으로 이동
        //닉네임 설정 이후 즉시 webgl로 이동
        const nicknameEvent = new CustomEvent("nicknameChange", {
          detail: {
            key: "nicknameChange",
            first,
            token,
            userinfo: {
              id: user.id,
              school: user.schoolName,
              name: user.name,
              nickName: user.nickName,
            },
          },
        });

        const loadingEvent = new CustomEvent("loading", {
          detail: false,
        });

        window.dispatchEvent(loadingEvent);

        window.dispatchEvent(nicknameEvent);
      } else {
        const loadflag = sessionStorage.getItem("load");
        if (!loadflag) {
          //기다렸다가 전송

          const interval = setInterval(() => {
            const loadflag = sessionStorage.getItem("load");
            if (loadflag) {
              clearInterval(interval);
              //sessionStorage.removeItem("load");
              window.dispatchEvent(loginevent);
            }
          }, 1000);
        } else {
          //sessionStorage.removeItem("load");
          window.dispatchEvent(loginevent);
        }
      }

      this.id = "";
      this.pw = "";
      this.name = "";
      this.grade = 0;
      this.classNum = 0;

      this.inputenabled();
    },
    schoolSearchBtnWidth() {
      if (this.$store.state.lang === "en") {
        return 220;
      } else {
        return 150;
      }
    },
  },
};
</script>

<style scoped>
.tabdiv {
  width: 1100px;
  height: 90px;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  position: relative;
  z-index: 10;
}

.logindiv {
  position: absolute;
  background-image: url("../assets/Login_Popup.png");
  background-size: 100% 90%;
  width: 1100px;
  height: 682px;
  top: 0;
  padding-top: 90px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

input {
  background-color: #f4fbff;
  width: 90%;
  font-size: 140%;
  border-radius: 30px;
  border-bottom: 9px solid #607ccd;
  outline: none;
  height: 14%;
  padding-left: 90px;
  font-family: notosans;
}

.inputcontainer {
  background-image: url("../assets/Login_Input.png");
  width: 80%;
  background-size: 100%;
}

.selectContainer {
  background-color: #f4fbff;
  width: 40%;
  border-radius: 15px;
  border-bottom: 9px solid #607ccd;
  outline: none;
  height: 60px;
  font-family: notosans;
  float: left;
  cursor: pointer;
}

.optionDown {
  background-image: url("../assets/optiondown.png");
  background-size: 6%;
  background-position-x: 95%;
  background-position-y: 14px;
}

.optionUp {
  background-image: url("../assets/optionup.png");
  background-size: 6%;
  background-position-x: 95%;
  background-position-y: 14px;
}

.idinput {
  background-image: url("../assets/idicon.png");
  background-size: 5%;
  background-position-x: 20px;
  background-position-y: 14px;
  height: 85px;
  margin-left: 55px;
  margin-top: 20px;
}

.pwinput {
  margin-top: 20px;
  height: 85px;
  background-image: url("../assets/pwicon.png");
  background-size: 5%;
  background-position-x: 20px;
  background-position-y: 14px;
  margin-left: 55px;
}

.loginbtn {
  background-image: url("../assets/Login_Btn_Login.png");
  background-size: 100%;
  width: 350px;
  height: 100px;
  cursor: pointer;
  margin-top: 55px;
  margin-left: 375px;
}

.loginbtn:hover {
  filter: brightness(0.8);
}

.whale {
  background-image: url("../assets/Login_Btn_Whale.png");
  width: 280px;
  height: 55px;
  background-size: 100%;
  position: absolute;
  bottom: 19%;
  left: 8%;
  cursor: pointer;
}

.whale:hover {
  filter: brightness(0.8);
}

.coolschool {
  width: 285px;
  height: 55px;
  background-color: white;
  cursor: pointer;
  position: absolute;
  bottom: 19%;
  left: 37%;
  border-radius: 10px;
  background-image: url("../assets/csc.png");
  background-size: 15%;
  background-position-x: 5%;
  background-position-y: 30%;
}

.coolschool:hover {
  filter: brightness(0.8);
}

.chathess {
  width: 285px;
  height: 55px;
  background-color: white;
  cursor: pointer;
  position: absolute;
  bottom: 19%;
  left: 68%;
  border-radius: 10px;
  background-image: url("../assets/chathesslogo.png");
  background-size: 10%;
  background-position-x: 5%;
  background-position-y: 45%;
}

.chathess:hover {
  filter: brightness(0.8);
}

input::-webkit-input-placeholder {
  color: #a4b5e5;
}

.swal2-popup {
  font-family: notosans;
  font-size: 1.6rem !important;
}

.maintenanceimg {
  width: 1000px;
  height: 490px;
  background-size: 100%;
  background-image: url("../assets/maintenanceimg.PNG");
}

.freeSigninBtn {
  width: 400px;
  height: 55px;
  background-image: url("../assets/Books_Free_Btn.png");
  background-size: 100%;
  margin-top: 25px;
  cursor: pointer;
  margin-left: 350px;
}

.nofreeSigninBtn:hover {
  filter: brightness(0.8);
}

.nofreeSigninBtn {
  width: 400px;
  height: 55px;
  background-image: url("../assets/Books_No_Free_Btn.png");
  background-size: 100%;
  margin-top: 25px;
  cursor: pointer;
  margin-left: 350px;
}

.freeSigninBtn:hover {
  filter: brightness(0.8);
}

.tabbtnleft {
  width: 100%;
  height: 100%;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  text-align: center;
}

.tabbtnright {
  width: 50%;
  height: 100%;
  float: right;
  border-top-right-radius: 40px;
  text-align: center;
  cursor: pointer;
}

.tabbtnright:hover {
  filter: brightness(0.8);
}

.tabbtnactive {
  background-color: #3f68d3;
  color: white;
}

.tabbtnunactive {
  background-color: #d9d9d9;
  color: #afafaf;
}

.tabbtntext {
  font-family: cookiebold;
  font-size: 37px;
  padding-top: 19px;
}

.schoolIcon {
  background-image: url("../assets/Books_School_Icon.png");
  background-size: 100%;
  width: 50px;
  height: 50px;
  float: left;
}

.schoolText {
  float: left;
  margin-left: 20px;
  font-family: notosans;
  font-size: 30px;
  padding-top: 23px;
}

.tabContentdiv {
  width: 1100px;
  height: 400px;
  margin-top: 12px;
}

.schoolSearchBtn {
  background-color: #3f68d3;
  border-radius: 10px;
  text-transform: none;
  letter-spacing: normal;
  text-indent: 0;
}

.optionContent {
  width: 37.9%;
  position: fixed;
  height: 200px;
  background-color: #f4fbff;
  margin-top: 40px;
  border-radius: 10px;
  font-size: 22px;
  overflow-y: scroll;
}

.selectoption {
  width: 100%;
  height: 50px;
  background-color: #f4fbff;
  padding-top: 10px;
  padding-left: 10px;
  cursor: pointer;
}

.selectoption:hover {
  filter: brightness(0.8);
}
</style>